'use strict';

var React = require('react');
var isForcedMotionValue = require('../../motion/utils/is-forced-motion-value.cjs');
var buildStyles = require('./utils/build-styles.cjs');
var createRenderState = require('./utils/create-render-state.cjs');
var isMotionValue = require('../../../../../../../motion-dom/dist/es/value/utils/is-motion-value.cjs');

function copyRawValuesOnly(target, source, props) {
    for (const key in source) {
        if (!isMotionValue.isMotionValue(source[key]) && !isForcedMotionValue.isForcedMotionValue(key, props)) {
            target[key] = source[key];
        }
    }
}
function useInitialMotionValues({ transformTemplate }, visualState) {
    return React.useMemo(() => {
        const state = createRenderState.createHtmlRenderState();
        buildStyles.buildHTMLStyles(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [visualState]);
}
function useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */
    copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState));
    return style;
}
function useHTMLProps(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect =
            style.WebkitUserSelect =
                style.WebkitTouchCallout =
                    "none";
        // Disable scrolling on the draggable direction
        style.touchAction =
            props.drag === true
                ? "none"
                : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined &&
        (props.onTap || props.onTapStart || props.whileTap)) {
        htmlProps.tabIndex = 0;
    }
    htmlProps.style = style;
    return htmlProps;
}

exports.copyRawValuesOnly = copyRawValuesOnly;
exports.useHTMLProps = useHTMLProps;
//# sourceMappingURL=use-props.cjs.map
